import Select from 'react-select';
import { SearchFieldStyles } from "../Searchfields/SearchFieldStyles";

const options = [
    { value: 1, label: "Módulo" },
    { value: 2, label: "Inversor" },
    { value: 3, label: "Outros" }
];

const TipoDeEquipamento = ({ field, placeholder, name, id, disabled=false }) => {
    return (
        <Select 
            options={options} 
            {...field}
            styles={SearchFieldStyles}
            placeholder={placeholder}
            name={name}
            isDisabled={disabled}
            id={id}
        />
    )
}

export { TipoDeEquipamento, options as OpcoesTipoDeEquipamento }